import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 挪用计划设置
 * 查询
 * @param {*} params
 */
export function apiEmbezzPlanList(data) {
  return request({
    url: BASE_API() + '/embezPlan/findEmbezPlan',
    method: 'post',
    data
  })
}

/**
 * 发货计划弹窗
 * 查询
 * @param {*} params
 */
export function apiFindDeliverPlan(data) {
  return request({
    url: BASE_API() + '/embezPlan/findDeliverPlan',
    method: 'post',
    data
  })
}

/**
 * 挪用计划设置
 * 保存
 * @param {*} params
 */
export function apiAddEmbezPlan(data) {
  return request({
    url: BASE_API() + '/embezPlan/addEmbezPlan',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/applyForGoods/embezzlePlan.js